import script from "./noticeDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./noticeDetailPage.vue?vue&type=style&index=0&id=f353f9ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f353f9ac"]])

export default __exports__